import {Component, ViewChild} from '@angular/core';
import {DialogAdapter, DialogParams, DialogResult} from '../../models/dialog-param';
import {ImageCropperComponent} from '../image-cropper/image-cropper.component';
import {Observable} from 'rxjs/Rx';
import {UserService} from '../../services/user.service';
import {NotifierService} from 'angular-notifier';
import {BUTTON_NAME} from '../../common/constants';
import {SharedValueService} from '../../services/shared-value.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-modal-cropper',
  templateUrl: './modal-cropper.component.html',
  styleUrls: ['./modal-cropper.component.scss'],
  preserveWhitespaces: false
})
export class ModalCropperComponent implements DialogAdapter {

  @ViewChild('imageCropper') cropper: ImageCropperComponent;

  public params: DialogParams;
  public prop: any;
  errorMsg = '';
  isInitial = true;
  tempAvatar: any;
  isValid = true;
  apiUrl = environment.apiURL + '/storage/';

  constructor(private userService: UserService,
              private notify: NotifierService,
              private shared: SharedValueService) {}

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
    if (this.isInitial) {
      this.isInitial = false;
      // Only call once when the user's avatar is exist
      if (this.prop.imageUrl) {
        setTimeout(() => {
          this.cropper.loadImage(this.prop.imageUrl, this.prop.id, true);
        });
      }
    } else {
      if (this.isValid) {
          const formData = new FormData();
          if (this.tempAvatar) {
            formData.append('avatar', this.tempAvatar, this.tempAvatar.name);
          } else {
            formData.append('avatar', null, null);
          }
          this.userService.updateAvatar(this.prop.id, formData).subscribe(response => {
            this.prop.isAPICallError = false;
            if (response.data) {
              this.shared.avatar = this.apiUrl + encodeURIComponent(response.data) + '?' + new Date().getTime();
            } else {
              this.shared.avatar = '';
            }
            this.params.subject.next(new DialogResult(BUTTON_NAME.OK, {avatar: this.shared.avatar}));
            this.params.subject.complete();
            this.isInitial = true;
            this.notify.notify('success', response.message);
          }, error => {
            this.prop.isAPICallError = true;
            this.prop.checkValidate = true;
            const message = error.body ? error.body.message : 'Error occurred!';
            this.notify.notify('error', message);
          });

      }
    }
  }

  uploadValidImage(event: any) {
    this.isValid = event;
    this.errorMsg = event ? '' : 'Please select a valid image file';
  }

  getPayload(): any {
    return Observable.create(observe => {
      this.cropper.getImageUrl(this.prop.id).subscribe(res => {
        if (res) {
          this.tempAvatar = res;
            observe.next({data: res, isCropperImage: true, isAPICallError: this.prop.isAPICallError});
          observe.complete();
        }
      }, error => {
        this.tempAvatar = null;
        observe.next({data: {}, isCropperImage: true, isAPICallError: this.prop.isAPICallError});
        observe.complete();
      });
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal-cropper/modal-cropper.component.ts